import { Button as ChakraButton } from "@chakra-ui/react";
import React from "react";
import { ButtonProps } from "../interfaces";

const Button: React.FC<ButtonProps> = ({
  w,
  minW,
  maxW,
  px,
  py,
  bg,
  borderRadius,
  color,
  isDisabled,
  onClick,
  text,
  hover,
  hoverOutlineColor,
  fontSize,
  fontFamily,
  isLoading,
  fontWeight,
  type,
  mb,
  form,
  display,
  border,
  h,
  mt,
  pos,
  wrapText,
  rightIcon,
  label,
}) => {
  return (
    <ChakraButton
      w={w}
      h={h ?? 10}
      minW={minW ?? "1.5rem"}
      maxW={maxW ?? "29rem"}
      mb={mb}
      mt={mt}
      px={px ?? "2.9rem"}
      py={py ?? "1rem"}
      pos={pos}
      justifyContent={"center"}
      alignItems={"center"}
      borderRadius={borderRadius ?? "3.125rem"}
      bg={bg ?? "#182E5E"}
      color={color ?? "#FFF"}
      isDisabled={isDisabled ?? false}
      onClick={onClick}
      display={display}
      border={border}
      isLoading={isLoading}
      cursor={"pointer"}
      rightIcon={rightIcon}
      // _hover={{ bg: hover ?? "#5e836e" }}
      aria-label={label}
      _disabled={{
        bgColor: "#182E5E",
        opacity: 0.6,
        color: "#fff",
        cursor: "not-allowed",
      }}
      fontSize={fontSize ?? "1rem"}
      fontFamily={fontFamily ?? "font2"}
      fontWeight={fontWeight ?? 300}
      type={type}
      form={form}
      {...(wrapText
        ? {
            style: {
              whiteSpace: "normal",
              wordWrap: "break-word",
            },
          }
        : {})}
      {...(hover && hoverOutlineColor
        ? {
            _hover: { outlineColor: `${hoverOutlineColor}` },
          }
        : {
            _hover: { bg: hover ?? "#182E5E" },
          })}
    >
      {text}
    </ChakraButton>
  );
};
export default Button;
